import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Panel } from "@/components/rc/shared";

const LABEL = {
  login: "Signed in", logout: "Signed out", login_failed: "Failed sign-in", user_created: "Account created", user_deleted: "Account deleted",
  user_deactivated: "Account deactivated", user_reactivated: "Account reactivated", role_changed: "Role changed", forced_logout: "Signed out by administrator",
  password_reset_issued: "Reset link created", password_reset: "Password reset", password_changed: "Password changed", mfa_enabled: "Two-step verification on",
  mfa_disabled: "Two-step verification off", access_code_changed: "Access code changed", organisation_created: "Workspace created",
  file_uploaded: "Document uploaded", file_downloaded: "Document downloaded", evidence_removed: "Evidence removed", report_exported: "Report exported",
  ehcp_record_deleted: "EHCP record deleted",
};

export const ActivityLog = ({ version }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/rc/audit").then(({ data }) => setRows(Array.isArray(data) ? data : [])).catch(() => setRows([]));
  }, [version]);
  return (
    <Panel id="ws-activity" eyebrow="Read-only audit trail" title="Activity log">
      <p className="mb-5 max-w-2xl text-ink-soft">Every sign-in, account change, upload, download and report export in your workspace is recorded here with the time and network address. Entries can't be edited or deleted.</p>
      <div className="max-h-[420px] overflow-auto rounded-2xl border-2 border-line" data-lenis-prevent>
        <table className="w-full min-w-[560px] border-collapse text-sm" data-testid="activity-table">
          <thead className="sticky top-0 bg-surface"><tr>{["When", "Event", "Who", "Address"].map((h) => <th key={h} scope="col" className="border-b-2 border-line px-3 py-2 text-left font-bold">{h}</th>)}</tr></thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={`${r.timestamp}-${i}`} className="border-b border-line">
                <td className="whitespace-nowrap px-3 py-2">{new Date(r.timestamp).toLocaleString("en-GB")}</td>
                <td className="px-3 py-2 font-bold">{LABEL[r.event] || r.event}</td>
                <td className="px-3 py-2">{r.user_name || "—"}</td>
                <td className="px-3 py-2 font-mono text-xs">{r.ip || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!rows.length && <p className="p-4 text-ink-soft">No activity yet.</p>}
      </div>
    </Panel>
  );
};
